import { axiosInstance } from './axios'

interface LoginPayload {
  nationid: string
  password: string
}

interface LoginResponse {
  token: string
}

export const loginRequest = async (data: LoginPayload) => {
  const res = await axiosInstance.post<LoginResponse>(
    '/login',
    data
  )

  return res.data
}

// const loginRequest = async () => {
//   const res = await axiosInstance.post('/login')

//   StoreAuth.getState().setToken(res.data.token)

//   router.replace('/') // or dashboard
// }
